// avstemming-loans-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avdl.toast.noBackend': 'El registro de préstamos no está conectado al backend.',
  'avdl.toast.registered': 'El préstamo se ha registrado',
  'avdl.toast.saved': 'El préstamo se ha guardado',
  'avdl.toast.removed': 'El préstamo se ha eliminado del registro',
  'avdl.toast.noAccount': 'El área de préstamos no tiene ninguna cuenta de conciliación en este período.',
  'avdl.nav.accounting': 'Datos contables',
  'avdl.nav.register': 'Resumen de préstamos',
  'avdl.nav.loansCount': '{count} préstamos',
  'avdl.nav.documents': 'Respaldo externo',
  'avdl.nav.missingCount': 'Faltan {count}',
  'avdl.nav.complete': 'Completo',
  'avdl.nav.difference': 'Cálculo de diferencias',
  'avdl.nav.verified': 'Verificado',
  'avdl.nav.items': 'Partidas de conciliación',
  'avdl.nav.openCount': '{count} abiertas',
  'avdl.nav.classification': 'Clasificación',
  'avdl.nav.noPlan': 'Sin plan',
  'avdl.nav.controls': 'Control y conclusión',
  'avdl.area.loans': 'Préstamos y deudas',
  'avdl.header.hintMissing': 'A {count} préstamos les falta documentación válida para el período.',
  'avdl.header.hintAll': 'Todos los préstamos registrados tienen respaldo para el período.',
  'avdl.header.title': 'Préstamos y deudas — registro, saldo del prestamista y clasificación',
  'avdl.header.responsible': 'Responsable: {name}',
  'avdl.header.unverified': '{amount} sin verificar',
  'avdl.header.allVerified': 'Todo el saldo está verificado',
  'avdl.header.summary': '{count} préstamos registrados con un saldo contabilizado total de {amount}.',
  'avdl.header.summaryUnverified': '{amount} de esto no se puede verificar porque falta documentación válida del prestamista para el período.',
  'avdl.header.summaryVerified': 'Todo el saldo está verificado con documentación del prestamista.',
  'avdl.header.zeroDiffNote': 'Una diferencia de cero no es lo mismo que una deuda conciliada. Un saldo contabilizado que ningún prestamista ha confirmado figura como no verificado y no se cuenta como conciliado, sin importar lo que muestren los demás préstamos.',
  'avdl.header.noAccountAlert': 'El área no tiene ninguna cuenta de conciliación en este período. Por eso no se pueden guardar la documentación ni las partidas de conciliación hasta que una cuenta de deuda forme parte del período.',
  'avdl.status.unverified': 'Sin verificar',
  'avdl.status.incomparable': 'No se puede comparar',
  'avdl.status.hasDifference': 'Tiene diferencia',
  'avdl.status.reconciled': 'Conciliado',
  'avdl.acc.title': 'Datos contables',
  'avdl.acc.source': 'Obtenido del balance de comprobación',
  'avdl.acc.sourceAt': 'Obtenido del balance de comprobación a {date}',
  'avdl.acc.booked': 'Saldo contabilizado de préstamos y deudas',
  'avdl.acc.opening': 'Saldo del período anterior',
  'avdl.acc.change': 'Variación de este período',
  'avdl.acc.loanCount': 'Número de préstamos registrados',
  'avdl.acc.unverified': 'Saldo contabilizado sin verificar',
  'avdl.acc.classificationGap': 'Posible desviación de clasificación',
  'avdl.acc.hideAccounts': 'Ocultar resumen de cuentas',
  'avdl.acc.showAccounts': 'Mostrar resumen de cuentas',
  'avdl.acc.colAccount': 'Cuenta',
  'avdl.acc.colClass': 'Clasificación',
  'avdl.acc.colOpening': 'Inicial',
  'avdl.acc.colMovement': 'Movimiento',
  'avdl.acc.colBooked': 'Saldo contabilizado',
  'avdl.acc.longTerm': 'Deuda a largo plazo',
  'avdl.acc.shortTerm': 'Deuda a corto plazo',
  'avdl.acc.unreadable': 'No determinado a partir del número de cuenta',
  'avdl.acc.noAccounts': 'No hay cuentas de préstamos ni de deudas en este período.',
  'avdl.flag.unverified': 'Sin verificar con el prestamista',
  'avdl.flag.difference': 'Diferencia con el prestamista',
  'avdl.flag.noPlan': 'Falta el plan de amortización',
  'avdl.flag.foreign': 'Préstamos en una moneda distinta de NOK',
  'avdl.flag.sharesAccount': 'Comparte cuenta del libro mayor',
  'avdl.tile.unverifiedHint': 'Préstamos sin confirmación de saldo ni extracto del préstamo que cubra el cierre del período.',
  'avdl.tile.withDifference': 'Préstamos con diferencia',
  'avdl.tile.withDifferenceHint': 'Préstamos verificados en los que el saldo contabilizado y el saldo del prestamista no coinciden.',
  'avdl.tile.noPlanHint': 'Sin un plan de amortización no se puede determinar la parte a corto plazo.',
  'avdl.tile.foreign': 'Préstamos en otra moneda',
  'avdl.tile.foreignHint': 'Debe comprobarse el tipo de cambio en la fecha de cierre del balance.',
  'avdl.tile.sharesAccountHint': 'Varios préstamos en la misma cuenta. El saldo de la cuenta no es entonces el saldo contabilizado de un solo préstamo y la diferencia no se puede calcular por préstamo.',
  'avdl.tile.unregistered': 'Cuentas de deuda sin préstamo',
  'avdl.tile.unregisteredHint': 'Saldo en una cuenta de deuda sin un préstamo registrado detrás. Se lista debajo del resumen de préstamos.',
  'avdl.card.title': 'Tarjeta de control',
  'avdl.card.loans': 'Préstamos registrados: {count}',
  'avdl.card.verified': 'Verificados con el prestamista: {count}',
  'avdl.card.unexplained': 'Diferencia sin explicar: {amount}',
  'avdl.card.activeFilter': 'Filtro activo: {label}',
  'avdl.card.removeFilter': 'Quitar filtro',
  'avdl.reg.resetFilter': 'Restablecer filtro',
  'avdl.reg.newLoan': 'Registrar préstamo',
  'avdl.reg.note': 'Los préstamos están en la configuración de la empresa, igual que las cuentas bancarias. Un préstamo registrado aquí permanece en el registro de préstamos y también lo usa el estado del balance.',
  'avdl.reg.colLoan': 'Prestamista / préstamo',
  'avdl.reg.colAccount': 'Cuenta',
  'avdl.reg.colBooked': 'Saldo contabilizado',
  'avdl.reg.colDocumented': 'Saldo documentado',
  'avdl.reg.colDifference': 'Diferencia',
  'avdl.reg.colDocumentation': 'Documentación',
  'avdl.reg.colStatus': 'Estado',
  'avdl.reg.sharedWithOther': 'Compartida con otro préstamo',
  'avdl.reg.shared': 'Compartida',
  'avdl.reg.open': 'Abrir',
  'avdl.reg.noMatch': 'Ningún préstamo coincide con el filtro.',
  'avdl.reg.noLoans': 'No hay préstamos registrados. Si hay deuda contabilizada en las cuentas anteriores, deben registrarse los préstamos antes de poder determinar la parte a corto plazo.',
  'avdl.reg.unregisteredOne': 'Una cuenta de deuda tiene saldo sin un préstamo registrado: {accounts}. Sin un plan de amortización no se puede determinar la parte a corto plazo.',
  'avdl.reg.unregisteredMany': '{count} cuentas de deuda tienen saldo sin un préstamo registrado: {accounts}. Sin un plan de amortización no se puede determinar la parte a corto plazo.',
  'avdl.cls.title': 'Clasificación de la deuda',
  'avdl.cls.bookedTotal': 'Deuda contabilizada total',
  'avdl.cls.verifiedDebt': 'Deuda documentada y verificada',
  'avdl.cls.unverifiedDebt': 'Deuda sin verificar',
  'avdl.cls.bookedLong': 'Contabilizada a largo plazo',
  'avdl.cls.bookedShort': 'Contabilizada a corto plazo',
  'avdl.cls.documentedNext12': 'Amortizaciones documentadas de los próximos 12 meses',
  'avdl.cls.plannedNext12': 'Amortizaciones de los próximos 12 meses según los planes',
  'avdl.cls.noPlan': 'Sin plan',
  'avdl.cls.countryNote': 'La distinción entre deuda a corto y a largo plazo se lee del plan de cuentas noruego. El país contable es {country}, por lo que la clasificación debe evaluarse manualmente.',
  'avdl.cls.unclassified': '{amount} de la deuda contabilizada está en cuentas fuera de la deuda a largo y a corto plazo. Hay que mover la cuenta, o el área se ha configurado con una cuenta que no es de deuda.',
  'avdl.cls.missingPlanOne': 'A un préstamo le falta el plan de amortización. Sin el plan no se pueden calcular las amortizaciones de los próximos doce meses y el campo queda vacío en lugar de estimarse.',
  'avdl.cls.missingPlanMany': 'A {count} préstamos les falta el plan de amortización. Sin el plan no se pueden calcular las amortizaciones de los próximos doce meses y el campo queda vacío en lugar de estimarse.',
  'avdl.cls.provisional': 'Provisional – debe confirmarse con un plan de amortización actualizado',
  'avdl.cls.gapNote': 'Vencen amortizaciones por {amount} en los próximos 12 meses según los planes propios de los préstamos, pero no están contabilizadas como deuda a corto plazo. La reclasificación es una valoración del despacho — los períodos de carencia, los incumplimientos de las condiciones del préstamo y la refinanciación posterior a la fecha del balance cambian el resultado sin que el plan lo muestre. Si se considera que la deuda debe moverse, se registra como una partida de conciliación con la clasificación «Feil kortsiktig/langsiktig klassifisering».',
  'avdl.derived.registered': 'Todas las cuentas de deuda con saldo tienen un préstamo registrado',
  'avdl.derived.registeredOpen': '{count} cuenta sin préstamo',
  'avdl.derived.registeredNone': 'Ninguna cuenta de deuda está sin préstamo',
  'avdl.derived.documented': 'Todos los préstamos tienen documentación válida para el período',
  'avdl.derived.documentedOpen': 'A {count} préstamos les falta un respaldo válido',
  'avdl.derived.documentedNone': 'Todos los préstamos están documentados',
  'avdl.derived.difference': 'La diferencia con los prestamistas está explicada',
  'avdl.derived.differenceOpen': '{amount} sin explicar',
  'avdl.derived.differenceNone': 'Ninguna diferencia sin explicar',
  'avdl.derived.interest': 'Los intereses devengados y las comisiones están tratados',
  'avdl.derived.interestOpen': '{amount} está informado pero no contabilizado',
  'avdl.derived.interestNone': 'No hay nada informado como no contabilizado',
  'avdl.derived.plan': 'Todos los préstamos tienen un plan de amortización con el que clasificar',
  'avdl.derived.planOpen': 'A {count} préstamos les falta el plan',
  'avdl.derived.planNone': 'Todos los préstamos tienen plan',
  'avdl.derived.classification': 'La parte a corto plazo concuerda con los planes',
  'avdl.derived.classificationOpen': '{amount} vence sin estar como corto plazo',
  'avdl.derived.classificationNone': 'Ninguna diferencia con los planes',
  'avdl.blocker.unregisteredOne': 'Una cuenta de deuda con saldo no tiene un préstamo registrado',
  'avdl.blocker.unregisteredMany': '{count} cuentas de deuda con saldo no tienen un préstamo registrado',
  'avdl.blocker.documentation': 'Falta documentación válida para {count} préstamos',
  'avdl.blocker.unverified': 'Un saldo contabilizado de {amount} no está verificado',
  'avdl.blocker.difference': '{amount} de la diferencia con los prestamistas está sin explicar',
  'avdl.blocker.accrued': 'Los intereses devengados y las comisiones por {amount} deben tratarse',
  'avdl.blocker.classification': 'Una posible desviación de clasificación de {amount} debe confirmarse',
  'avdl.blocker.pointOne': 'Queda un punto de control',
  'avdl.blocker.pointMany': 'Quedan {count} puntos de control',
  'avdl.checks.title': 'Controles',
  'avdl.checks.colCheck': 'Control',
  'avdl.checks.colFindings': 'Hallazgos',
  'avdl.checks.colStatus': 'Estado',
  'avdl.checks.needsReview': 'Requiere revisión',
  'avdl.checks.none': 'Sin hallazgos',
  'avdl.check.title': 'Lista de comprobación profesional',
  'avdl.check.titleReadOnly': 'Lista de comprobación profesional (de quien la realiza, solo lectura)',
  'avdl.check.noPoints': 'No hay puntos de control definidos para préstamos y deudas en este período.',
  'avdl.check.scope': 'Los puntos se aplican a toda el área. Una marca se guarda en todas las cuentas de deuda del período.',
  'avdl.check.groupDerived': 'Se deduce de los préstamos',
  'avdl.check.groupAssessments': 'Evaluaciones profesionales',
  'avdl.check.groupReady': 'Preparación',
  'avdl.check.count': '{done} de {total}',
  'avdl.check.followsNumbers': 'Se deduce de las cifras',
  'avdl.check.performedBy': 'Realizado por {name}',
  'avdl.check.completed': '{done} de {total} puntos de control completados',
  'avdl.concl.title': 'Conclusión y aprobación',
  'avdl.concl.loansChecked': 'Préstamos controlados',
  'avdl.concl.loansWithoutDocs': 'Préstamos sin documentación válida',
  'avdl.concl.unexplainedDifference': 'Diferencia de conciliación sin explicar',
  'avdl.concl.accrued': 'Intereses devengados y comisiones',
  'avdl.concl.conclusion': 'Conclusión',
  'avdl.concl.placeholder': '¿Qué muestra la revisión de préstamos y deudas de este período?',
  'avdl.concl.savedAs': 'Se guarda como justificación del punto de control «{label}».',
  'avdl.concl.remainingRisk': 'Riesgo pendiente',
  'avdl.concl.noRisk': 'No queda nada que impida enviar el área a revisión.',
  'avdl.concl.followUp': 'Seguimiento del próximo período',
  'avdl.concl.noFollowUp': 'Ninguna partida está marcada para seguimiento y todos los préstamos tienen respaldo para el período.',
  'avdl.concl.missingEvidence': 'Falta respaldo',
  'avdl.concl.getStatement': 'Solicita un extracto actualizado del préstamo. {status}.',
  'avdl.common.openLoan': 'Abrir el préstamo',
  'avdl.concl.reconItem': 'Partida de conciliación',
  'avdl.common.followed': 'En seguimiento',
  'avdl.concl.measure': 'Medida: {text}',
  'avdl.concl.noMeasure': 'Sin medidas anotadas',
  'avdl.concl.deadline': 'Plazo {date}',
  'avdl.concl.send': 'Enviar el área a revisión',
  'avdl.concl.oneLeft': 'Queda una cosa antes de poder enviar el área.',
  'avdl.concl.manyLeft': 'Quedan {count} cosas antes de poder enviar el área.',
  'avdl.docs.title': 'Respaldo externo',
  'avdl.docs.unverifiedNote': '{amount} de la deuda contabilizada no se puede verificar porque falta documentación válida del prestamista para el período:',
  'avdl.docs.colDocument': 'Documento',
  'avdl.docs.colType': 'Tipo',
  'avdl.docs.colBalanceDate': 'Fecha del saldo',
  'avdl.docs.colLender': 'Prestamista',
  'avdl.docs.notLinked': 'No vinculado a un préstamo',
  'avdl.docs.view': 'Ver',
  'avdl.docs.uploaded': 'Subido:',
  'avdl.docs.source': 'Origen:',
  'avdl.docs.sourceClient': 'El cliente',
  'avdl.docs.sourceFirm': 'El despacho',
  'avdl.docs.by': 'Por:',
  'avdl.docs.accounts': 'Cuentas:',
  'avdl.docs.loanStatement': 'Extracto del préstamo',
  'avdl.docs.requestDocs': 'Pedir documentación al cliente',
  'avdl.docs.empty': 'No se ha adjuntado documentación en el área de préstamos en este período.',
  'avdl.docs.footer': 'Los documentos se suben en la pestaña de documentos del panel derecho y se vinculan al préstamo en el panel del préstamo, donde también se registran el saldo y la fecha del saldo que se leen del documento.',
  'avdl.diff.critical': 'Desviación crítica – debe aclararse antes de la aprobación',
  'avdl.diff.unexplained': 'Diferencia sin explicar',
  'avdl.diff.difference': 'Diferencia',
  'avdl.diff.partA': 'A. Conciliación de préstamos documentados',
  'avdl.diff.bookedCovered': 'Saldo contabilizado cubierto por documentación',
  'avdl.diff.documentedFromLenders': 'Saldo documentado por los prestamistas',
  'avdl.diff.preliminary': 'Diferencia provisional',
  'avdl.diff.explained': 'Diferencias explicadas',
  'avdl.diff.unexplainedLabel': 'Diferencia sin explicar',
  'avdl.diff.noneVerified': 'Todavía ningún préstamo tiene documentación válida para el período. Por tanto, aquí no hay nada que conciliar — todo el saldo figura en B.',
  'avdl.diff.partB': 'B. Saldo sin verificar',
  'avdl.diff.criticalDocs': 'Crítico – falta documentación',
  'avdl.diff.unverifiedBooked': 'Saldo contabilizado sin verificar',
  'avdl.diff.debtWithoutLoan': 'Cuentas de deuda sin préstamo registrado',
  'avdl.diff.notADifference': 'Esto no es una diferencia. Es deuda que ninguna fuente externa ha confirmado y, por tanto, no puede marcarse como «conciliada» solo porque las cifras coincidan por casualidad.',
  'avdl.diff.requestDocsCustomer': 'Pedir documentación al cliente',
  'avdl.diff.partC': 'C. Otros asuntos abiertos',
  'avdl.diff.accruedInterest': 'Intereses devengados no contabilizados',
  'avdl.diff.fees': 'Comisiones no contabilizadas',
  'avdl.diff.foreign': 'Préstamos en moneda extranjera',
  'avdl.diff.possibleMisclass': 'Posible clasificación errónea a corto/largo plazo',
  'avdl.diff.footerNote': 'Los asuntos identificados no cuentan como partidas resueltas o explicadas hasta que la medida se haya ejecutado o documentado. Los importes de aquí están informados en los préstamos, no contabilizados.',
  'avdl.items.title': 'Partidas de conciliación',
  'avdl.items.noAccount': 'El área no tiene ninguna cuenta de conciliación en este período, por lo que las partidas no se pueden guardar.',
  'avdl.items.note': 'Las partidas explican la diferencia con los prestamistas. El importe y la justificación son lo que cuenta en el cálculo — una partida sin justificación no explica nada.',
  'avdl.items.description': 'Descripción',
  'avdl.items.noLoan': 'No vinculada a un préstamo',
  'avdl.items.amount': 'Importe',
  'avdl.items.add': 'Añadir',
  'avdl.items.colLoan': 'Préstamo',
  'avdl.items.colDate': 'Fecha',
  'avdl.items.colAction': 'Medida',
  'avdl.items.resolved': 'Resuelta',
  'avdl.items.open': 'Abierta',
  'avdl.items.reopen': 'Reabrir',
  'avdl.items.markResolved': 'Marcar como resuelta',
  'avdl.items.delete': 'Eliminar',
  'avdl.items.empty': 'No hay partidas de conciliación registradas.',
  'avdl.carry.title': 'Trasladar el saldo al cierre del período',
  'avdl.drawer.close': 'Cerrar',
  'avdl.carry.note': 'El saldo del prestamista en la fecha del documento, actualizado con lo ocurrido después. Las amortizaciones reducen la deuda; las nuevas disposiciones, los intereses y las comisiones la aumentan.',
  'avdl.carry.baseBalance': 'Saldo según el documento',
  'avdl.carry.baseDate': 'Fecha del saldo del documento',
  'avdl.carry.installments': 'Amortizaciones posteriores a la fecha del documento',
  'avdl.carry.drawdowns': 'Nuevas disposiciones',
  'avdl.carry.interestAndFees': 'Intereses y comisiones',
  'avdl.carry.other': 'Otros movimientos',
  'avdl.carry.computed': 'Saldo calculado al cierre del período',
  'avdl.carry.comparedToLedger': 'Comparado con el libro mayor',
  'avdl.carry.apply': 'Usar el saldo trasladado en la conciliación',
  'avdl.carry.cancel': 'Cancelar',
  'avdl.drawer.loanFallback': 'Préstamo',
  'avdl.drawer.noLoanNumber': 'Sin número de préstamo',
  'avdl.drawer.accountPrefix': 'cuenta {account}',
  'avdl.drawer.loanHeading': 'El préstamo',
  'avdl.drawer.loanNote': 'Se guarda en el registro de préstamos de la empresa y se aplica a todos los períodos.',
  'avdl.drawer.lender': 'Prestamista',
  'avdl.drawer.loanName': 'Nombre del préstamo',
  'avdl.drawer.loanNumber': 'Número de préstamo',
  'avdl.drawer.ledgerAccount': 'Cuenta del libro mayor',
  'avdl.drawer.ledgerAccountHint': 'La cuenta en la que está contabilizado el préstamo',
  'avdl.drawer.chooseAccount': 'Elegir cuenta',
  'avdl.drawer.currency': 'Moneda',
  'avdl.drawer.originalAmount': 'Importe original del préstamo',
  'avdl.drawer.interestRate': 'Tipo de interés',
  'avdl.drawer.repaymentType': 'Tipo de amortización',
  'avdl.drawer.termsPerYear': 'Plazos por año',
  'avdl.drawer.monthly': 'Mensual',
  'avdl.drawer.quarterly': 'Trimestral',
  'avdl.drawer.semiannual': 'Semestral',
  'avdl.drawer.annual': 'Anual',
  'avdl.drawer.installmentAmount': 'Importe de la cuota',
  'avdl.drawer.remainingTerms': 'Plazos restantes',
  'avdl.drawer.startDate': 'Fecha de inicio',
  'avdl.drawer.endDate': 'Fecha de fin',
  'avdl.drawer.interestOnlyUntil': 'Carencia de capital hasta',
  'avdl.drawer.security': 'Garantía/prenda',
  'avdl.drawer.next12': 'Amortizaciones de los próximos 12 meses según el plan',
  'avdl.drawer.planInsufficient': 'El plan no basta',
  'avdl.drawer.bookedOnAccount': 'Saldo contabilizado en la cuenta',
  'avdl.drawer.needsAccount': 'El préstamo debe estar en una cuenta del libro mayor.',
  'avdl.drawer.saveLoan': 'Guardar el préstamo',
  'avdl.drawer.removeLoan': 'Eliminar el préstamo del registro',
  'avdl.drawer.periodDocs': 'Documentación del período',
  'avdl.drawer.periodDocsNote': 'El saldo del prestamista de este período. Se guarda en la conciliación, no en el préstamo.',
  'avdl.drawer.lenderBalance': 'Saldo según el prestamista',
  'avdl.drawer.balanceDate': 'Fecha del saldo',
  'avdl.drawer.periodEndIs': 'El cierre del período es el {date}',
  'avdl.drawer.lenderPerDoc': 'Prestamista según el documento',
  'avdl.drawer.linkedDoc': 'Documento vinculado',
  'avdl.drawer.notLinked': 'No vinculado',
  'avdl.drawer.accruedInterest': 'Intereses devengados no contabilizados',
  'avdl.drawer.fees': 'Comisiones no contabilizadas',
  'avdl.drawer.docIssue': 'Objeción al documento',
  'avdl.drawer.comment': 'Comentario',
  'avdl.drawer.commentPlaceholder': '¿Qué muestra la documentación y qué queda pendiente?',
  'avdl.drawer.documentDate': 'la fecha del documento',
  'avdl.drawer.carriedNote': 'El saldo se ha trasladado desde {date}: {base} − amortizaciones {installments} + disposiciones {drawdowns} + intereses y comisiones {fees} + otros {other}.',
  'avdl.drawer.saveDocs': 'Guardar la documentación',
  'avdl.drawer.carryForward': 'Trasladar el saldo al cierre del período',
});
